import { TCountryFlagSize } from './types';

export const COUNTRY_FLAG_HEIGHTS: Record<TCountryFlagSize, number> = {
	xs: 9,
	s: 10,
	m: 12,
	l: 14,
	xl: 16,
	xxl: 18,
};

/** Codes used by tax authorities that are not ISO 3166-1 alpha-2 */
export const COUNTRY_CODE_FLAG_ALIASES: Record<string, string> = {
	EL: 'gr',
	XI: 'gb',
	UK: 'gb',
};

/** Neutral placeholder shipped with flag-icons */
export const UNKNOWN_FLAG_CODE = 'xx';
